export default __webpack_public_path__ + "assets/resizedBrossard-min.9d78cbaa.webp";